// extracted by mini-css-extract-plugin
export default {"block":"RequestPeriod_block__KK965","duration":"RequestPeriod_duration__g4pLA","line":"RequestPeriod_line__Mm8rz","dash":"RequestPeriod_dash__OUDLJ"};